// Aqui se centralizan los strings de las rutas al API
export class API {
    public static webApiBase = process.env.VUE_APP_ROOT_API;

    public static login = API.webApiBase + 'Login';

    //USER

    public static user = API.webApiBase + 'User';
    public static userDetail = API.webApiBase + 'User/{0}';

    // PERMISSIONS
    public static permissions = API.webApiBase + 'Login/Permissions';

    //ROLES
    public static roles = API.webApiBase + 'User/GetRoles';
    public static ambitRoles = API.webApiBase + 'User/GetAmbitRoles';
    public static allRoles = API.webApiBase + 'User/GetAllRoles';
    public static userRoles = API.webApiBase + 'User/GetUserRoles?id={0}';
    public static deleteUserRole = API.webApiBase + 'User/{0}/DeleteUserRole?roleId={1}';
    public static addUserRole = API.webApiBase + 'User/{0}/AddUserRole?roleId={1}';

    public static noticias = API.webApiBase + 'Noticia/CargarNoticias';

    public static collaborativeAreaContainer = API.webApiBase + 'Container';

    public static fileManager = API.webApiBase + 'FileManager';

    public static eventos = API.webApiBase + 'Event';

    public static posts = API.webApiBase + 'Post';

    public static replys = API.webApiBase + 'Reply';

    public static templates = API.webApiBase + 'Template';
    public static templateVersions = API.webApiBase + 'TemplateVersion';
    public static templateVersionsDetail = API.webApiBase + 'TemplateVersion/{0}';

    public static fields = API.webApiBase + 'Field';

    // CNAE CODE
    public static cnaeCode = API.webApiBase + 'CnaeCode';
    public static cnaeCodeDetail = API.webApiBase + 'CnaeCode/{0}';

    // LER CODE
    public static lerCode = API.webApiBase + 'LerCode';
    public static lerCodeDetail = API.webApiBase + 'LerCode/{0}';

    // SECTOR
    public static sector = API.webApiBase + 'Sector';
    public static sectorDetail = API.webApiBase + 'Sector/{0}';

    //UNIT TYPE
    public static unitType = API.webApiBase + 'UnitType';
    public static unitTypeDetail = API.webApiBase + 'UnitType/{0}';

    //FIELD TYPE
    public static fieldType = API.webApiBase + 'FieldType';
    public static fieldTypeDetail = API.webApiBase + 'FieldType/{0}';

    //LIST VALOURS
    public static values = API.webApiBase + 'Values';
    public static valuesDetail = API.webApiBase + 'Values/{0}';

    //ASSOCIATION
    public static association = API.webApiBase + 'Association';
    public static associationDetail = API.webApiBase + 'Association/{0}';

    //CATEGORY
    public static formattedCategory = API.webApiBase + 'FormattedCategory/GetFormattedCategoryList';

    public static categoryFirstLevel = API.webApiBase + 'CategoryFirstLevel';
    public static categoryFirstLevelDetail = API.webApiBase + 'CategoryFirstLevel/{0}';
    public static categoriesFirstLevelAnonymous = API.webApiBase + 'CategoryFirstLevel/CategoriesAnonymous';

    public static categorySecondLevel = API.webApiBase + 'CategorySecondLevel';
    public static categorySecondLevelDetail = API.webApiBase + 'CategorySecondLevel/{0}';

    public static categoryThirdLevel = API.webApiBase + 'CategoryThirdLevel';
    public static categoryThirdLevelDetail = API.webApiBase + 'CategoryThirdLevel/{0}';

    public static categoryFourthLevel = API.webApiBase + 'CategoryFourthLevel';
    public static categoryFourthLevelDetail = API.webApiBase + 'CategoryFourthLevel/{0}';

    // CHAT
    public static chat = API.webApiBase + 'Chat';
    public static chatRoomCrud = API.webApiBase + 'Room';
    public static chatUserInRoomCrud = API.webApiBase + 'UserInRoom';

    // NOTIFICATIONS
    public static notifications = API.webApiBase + 'Notification/userNotifications';
    public static notificationUserName = API.webApiBase + 'Notification/userName';
    public static notificationUsers = API.webApiBase + 'Notification/users';

    // OFFER DEMMAND
    public static offerDemand = API.webApiBase + 'OfferDemand';
    public static offerDemandDetail = API.webApiBase + 'OfferDemand/{0}';
    public static squidExecuteAlgorithm = API.webApiBase + 'OfferDemand/CreatedOfferOrDemand';

    // COLLABORATIVE AREA
    public static collaborativeArea = API.webApiBase + 'CollaborativeArea';
    public static collaborativeAreaDetail = API.webApiBase + 'CollaborativeArea/{0}';

    // EVENTS
    public static event = API.webApiBase + 'Event';

    // RESPONSE ALGORITHM
    public static responseAlgorithm = API.webApiBase + 'ResponseAlgorithm';
    
    // CONTACT FORM
    public static contactForm = API.webApiBase + 'ContactForm';

    // ALGORITHMS
    public static algorithm = API.webApiBase + 'Algorithm';
    public static algorithmDetail = API.webApiBase + 'Algorithm/{0}';
    public static squidRegister = API.webApiBase + 'Algorithm/Register/{0}';
    public static squidUnregister = API.webApiBase + 'Algorithm/Unregister/{0}';
    public static squidChangeStatus = API.webApiBase + 'Algorithm/ChangeStatus';
}
